import type { Tone } from "./state";

// Literal class names (Tailwind scans source text, so classes are never built by concatenation).
export const toneClasses: Record<Tone, { fg: string; bg: string; border: string; badge: string }> =
  {
    neutral: {
      fg: "text-neutral-fg",
      bg: "bg-neutral-bg",
      border: "border-neutral-border",
      badge: "bg-neutral-bg text-neutral-fg",
    },
    action: {
      fg: "text-action-fg",
      bg: "bg-action-bg",
      border: "border-action-border",
      badge: "bg-action-bg text-action-fg",
    },
    transit: {
      fg: "text-transit-fg",
      bg: "bg-transit-bg",
      border: "border-transit-border",
      badge: "bg-transit-bg text-transit-fg",
    },
    success: {
      fg: "text-success-fg",
      bg: "bg-success-bg",
      border: "border-success-border",
      badge: "bg-success-bg text-success-fg",
    },
    warning: {
      fg: "text-warning-fg",
      bg: "bg-warning-bg",
      border: "border-warning-border",
      badge: "bg-warning-bg text-warning-fg",
    },
    danger: {
      fg: "text-danger-fg",
      bg: "bg-danger-bg",
      border: "border-danger-border",
      badge: "bg-danger-bg text-danger-fg",
    },
  };
